import React from 'react';
import Modal from '../../Components/Modal';
import JobDetails from '../../Components/Formatting/Grids/JobDetails';
import ButtonRow from '../../Components/Button/ButtonRow';
import Button from '../../Components/Button/Button';

const JobModal = ({job, onClose}) => {

    return <Modal title="Job Details" isOpen={!!job} setIsOpen={onClose} dismissible>
        {job && <JobDetails job={job} customer={job.customer} />}
        <ButtonRow>
            <Button theme="secondary" label="Close" onClick={onClose} />
        </ButtonRow>
    </Modal>
}

export default JobModal;
